export default __webpack_public_path__ + "static/media/sticker-14.7e551696.png";